module.exports = __webpack_public_path__ + "img/iphone3.1318bcef.png";